

export const actionTypes = {
    NUMBER: 'CONTACT NUMBER',
    NAME: 'CONTACT NAME',
    ADDRESS: 'CONTACT ADDRESS',
}


export const setNumber = (number) => dispatch => {
    return dispatch({ type: actionTypes.NUMBER, number: number, ts: Date.now() })
}

export const setName = (name) => dispatch => {
    return dispatch({ type: actionTypes.NAME, name: name, ts: Date.now() })
}

export const setAddress = (address) => dispatch => {
    return dispatch({ type: actionTypes.ADDRESS, address: address, ts: Date.now() })
}

/**
 * function fetchPosts(subreddit) {
  return dispatch => {
    dispatch(requestPosts(subreddit))
    return fetch(`https://www.reddit.com/r/${subreddit}.json`)
      .then(response => response.json())
      .then(json => dispatch(receivePosts(subreddit, json)))
  }
}

 */


// WEBPACK FOOTER //
// store/contact/action.ts